import React, { useState, useEffect, useRef} from 'react';
import { Container, Row, Col, Stack, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { doAdminLogin } from '../../../Service';
import { setAdminUserData, setAdminToken } from '../../../reducers/User/action';
import { useDispatch} from 'react-redux';
import Swal from "sweetalert2";
import { InfinitySpin } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ReCAPTCHA from "react-google-recaptcha";
import { HtmlTagValidation, BlockSQLInjection} from '../../Reusable';
import { JsonEncode, JsonDecode } from '../../Reusable/JsonModify';

export default function Login() {
    // state declaration
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const recaptcha = useRef();

    const initialValues = { email: "", password: "" };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [passEye, setPassEye] = useState(false);

    // get customer privacy preference data from store
    const privacyStatus =  useSelector(store => store.user['privacypreference']);

    // get Admin data from store
    const userData =  useSelector(store => store.user['adminuser']);

    useEffect(() => {

        if ( privacyStatus === true ) {
            var btn1 = document.getElementById("termsfeed_pc1_sticky_dnsmpi_element_open");
            var btn2 = document.getElementById("termsfeed_pc1_sticky_element_open");

            if ( btn1 && btn2 ) {
                btn1.classList.remove('ppbtnhide');
                btn2.classList.remove('ppbtnhide');
            }

        } else if ( privacyStatus === false ) {
            var btn1 = document.getElementById("termsfeed_pc1_sticky_dnsmpi_element_open");
            var btn2 = document.getElementById("termsfeed_pc1_sticky_element_open");

            if ( btn1 && btn2 ) {
                btn1.classList.add('ppbtnhide');
                btn2.classList.add('ppbtnhide');
            }

        }

        if ( userData != null ) {
            navigate('/admin/');
        }

    }, [])

    // input field onchange
    const hanldeChange = ( e ) => {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
            ...prevState,
            [field]:  value  
        }));
    }

    // login form onsubmit
    const handleSubmit = async ( e ) => {
        e.preventDefault();
        const errorCount = validate(formValues);
        setFormErrors(errorCount);

        if ( errorCount.status ) {
            // formValues['reCaptchaToken'] = recaptcha.current.getValue();

            let jsonData = await JsonEncode(formValues).then(result => {
                return result
            }).catch(error => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    showConfirmButton: false,
                    text: error,
                    timer: 3000
                }); 
            });
            
            if ( jsonData ) {
                let loginPayload = {data : jsonData};
                doAdminLogin(loginPayload).then(res => handleResponse(res));
                setLoader(true);
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    showConfirmButton: false,
                    text: 'Something went wrong, Please try after sometimes',
                    timer: 3000
                }); 
            }

        }

    }

    // login api response
    const handleResponse = async ( response ) => {

        let decryptData = await JsonDecode(response.data.data).then(result => {
            return result
        }).catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: error,
                timer: 3000
            }); 
        });

        if ( decryptData.statusCode === 200 ) {
            dispatch(setAdminToken(decryptData.jwtToken));
            const userData = {roleId:decryptData.roleId, userName:decryptData.userName, roleName:decryptData.roleName}
            dispatch(setAdminUserData(userData));
            setLoader(false);
           navigate('/admin/dashboard');
        } else {
            // recaptcha.current.reset();
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: decryptData.statusMessage,
                timer: 3000
              }); 
              setFormValues(formValues);
              setLoader(false);
        }  

    }

    // input field validation
    const validate = ( values ) => {
        const errors = {};
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        errors.status = true;

        if ( !values.email ) {
            errors.email = 'Email is required';
            errors.status = false;
        } else if ( !regex.test(values.email) ) {
            errors.email = "This is not a valid email format!";
            errors.status = false;
        }

        if( !values.password ) {
            errors.password = 'Password is required';
            errors.status = false;
        }

        // if ( recaptcha.current.getValue() === '' ) {
        //     errors.captcha = 'Captcha is required';
        //     errors.status = false;
        // }

        const validations = {
            email: HtmlTagValidation(values.email),
            password: HtmlTagValidation(values.password)
        };

        Object.entries(validations).forEach(([key, value]) => {
            
            if ( !value ) {
                errors[key] = 'Invalid input';
                errors.status = false;
            }

        });

        return errors;
    }

    const confrimPassView = () => {
        setPassEye(prevState => !prevState);
    }

    return(
        <section className='login-bg'>
            <Container>
                <Row className="justify-content-md-center ">
                    <Col md="auto">
                        <div className='text-center'>
                            <img src='images/logo.png'/>
                        </div>
                        <h1 className="text-center">Admin <br></br> <span>Login</span></h1>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-4" controlId="formBasicEmail">
                                <Form.Label>Email <span>*</span></Form.Label>
                                <Form.Control autoComplete="off" onKeyDown={BlockSQLInjection} type="email" name="email" defaultValue={formValues.email} onChange={hanldeChange}/>
                                <p className="error">{formErrors.email}</p>
                            </Form.Group>
                            <Form.Group className="mb-4 passwordRow" controlId="formBasicPassword">
                                <Form.Label>Password <span>*</span></Form.Label>
                                <FontAwesomeIcon icon={passEye === false ? faEye : faEyeSlash} className='passwordEye' onClick={confrimPassView}/>
                                <Form.Control autoComplete="off" onKeyDown={BlockSQLInjection} type={passEye === false ? 'password' : 'text'}  name="password" defaultValue={formValues.password} onChange={hanldeChange}/>
                                <p className="error">{formErrors.password}{formErrors.invalid}</p>
                            </Form.Group>
                            <Stack gap={3} className="mx-autos">
                                {/* <Form.Group as={Col} controlId="formCaptchaLoad">
                                    <Form.Label>Captcha <span>*</span></Form.Label>
                                    <ReCAPTCHA size="normal" className='newGoogleCaptcha' ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
                                    <p className="error">{formErrors.captcha}</p>
                                </Form.Group> */}
                                <div style={{textAlign : 'right'}}>
                                    <Link to="/adminforgotpassword" className="text-end forgot" style={{textDecoration: "none"}}>Forgot Password</Link>
                                </div> 
                                {
                                    loader === true ? 
                                        <div style={{textAlign : 'center'}}>
                                            <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
                                        </div>
                                    :
                                        <Button type='submit' variant="secondary"  onClick={handleSubmit} >Login <img src='images/arrow-right.svg'/></Button>
                                }
                            </Stack>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </section>
    )
} 